import { render, staticRenderFns } from "./ReportTablePreview.vue?vue&type=template&id=10761a8c&"
import script from "./ReportTablePreview.vue?vue&type=script&lang=js&"
export * from "./ReportTablePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports